import { createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../config/api';

export const fetchOccupancyInsights = createAsyncThunk(
  'analytics/fetchOccupancyInsights',
  async ({ landlordId, propertyId, startDate, endDate, month } = {}) => {
    const response = await api.get('/property/overview/occupancy-insights', {
      params: {
        landlordId,
        propertyId,
        startDate,
        endDate,
        month
      },
    });
    return response.data;
  }
);
